import BasePressureField from '../BasePressureField';
import PressureProps from '../../PressureProps';
import React from 'react';
import { observer } from 'mobx-react';

const MaximumValueField =
  ({ translate, model, readonly }: PressureProps) =>
    <BasePressureField {...{
      readonly,
      numberValidationSchema: model.maximalPressureMaxSchema.label(
        translate(x => x.forms.airdome.restrictions.pressure.maximalPressureMax)
      ),
      inputId: 'UpperBound_PressureMaximal_Field',
      label: translate(x => x.forms.airdome.restrictions.pressure.maximalPressureMax),
      setValue: x => model.maximalPressureMax.setValue(x),
      value: model.maximalPressureMax.Value
    }} />;

export default observer(MaximumValueField);
